/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconDeviceImac = createReactComponent("outline", "device-imac", "IconDeviceImac", [["path", { "d": "M3 4a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v12a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-12z", "key": "svg-0" }], ["path", { "d": "M3 13h18", "key": "svg-1" }], ["path", { "d": "M8 21h8", "key": "svg-2" }], ["path", { "d": "M10 17l-.5 4", "key": "svg-3" }], ["path", { "d": "M14 17l.5 4", "key": "svg-4" }]]);

export { IconDeviceImac as default };
//# sourceMappingURL=IconDeviceImac.mjs.map
